// This file is generated do not modify manually
export const personalArchive = [
    { path: 'MessagesList', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
    { path: 'PrivateDocumentsList', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
    { path: 'MessagesListSearch', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
    { path: 'PrintMessage', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
    { path: 'MessagesPanel', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
    { path: 'UnreadMessages', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
    { path: 'ArchiveIcon', loadChildren: () =>
    import('./personal-archive.module').then(m => m.PersonalArchiveModule) },
];
